export var GetStartedTaskStatus;
(function (GetStartedTaskStatus) {
    GetStartedTaskStatus["Incomplete"] = "Incomplete";
    GetStartedTaskStatus["Completed"] = "Completed";
})(GetStartedTaskStatus || (GetStartedTaskStatus = {}));
//# sourceMappingURL=GetStartedTaskStatus.js.map